// ======================================================================
// File Name       : SelectBoxDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import * as csvActions from '../../../actions/csvDownloadAction';
import MessageSearch from '../../MessageSearch';
import ModalWrapper from '../../modal/ModalWrapper';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../../constants/UserAttributeConstants';
import RenderField from '../../../utils/ReduxFormUtils';
import CustomButton from '../../button/CustomButton';
import BoxList from './BoxList';
import SelectedBoxList from './SelectedBoxList';

class SelectBoxDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      checkedBoxList: [],
      checkedBoxOnModal: [],
      isAllowShowSearchMessage: false,
    };
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.handleAddBox = this.handleAddBox.bind(this);
    this.handleRemoveAllBoxes = this.handleRemoveAllBoxes.bind(this);
    this.handleRemoveBox = this.handleRemoveBox.bind(this);
    this.handleSearchBox = this.handleSearchBox.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  /**
   * Init data
   */
  componentDidMount() {
    this.props.dispatch(csvActions.initBoxList());
  }

  /**
   * Unmount component
   */
  componentWillUnmount() {
    this.props.dispatch(csvActions.unMountBoxDialog());
  }

  /**
   * Handle OK button
   */
  onOK() {
    const { addedBoxList } = this.props;
    this.props.dispatch(csvActions.addCheckedBoxToTargetList(addedBoxList));
    this.props.hideModal();
  }

  /**
   * Handle 戻る button
   */
  onCancel() {
    // Reset addedBoxList on Store
    this.props.dispatch(csvActions.resetBox());
    this.props.hideModal();
  }

  scrollToBottom() {
    const node = document.getElementById('scroll-table-box');
    node.scrollIntoView({ behavior: 'smooth' });
  }

  /**
   * Handle 全選択/解除 button
   */
  handleCheckAll() {
    const { targetBox, csvDownload } = this.props;
    const { checkedBoxOnModal, checkedBoxList } = this.state;
    const checkBoxIdChecked = [];
    if (targetBox.allSecernIds && targetBox.allSecernIds.length) {
      targetBox.allSecernIds.map((boxSecernId) => {
        const pos = checkedBoxOnModal.indexOf(boxSecernId);
        if (pos > -1) {
          checkBoxIdChecked.push(pos);
        }
      });

      if (checkBoxIdChecked.length === targetBox.allSecernIds.length) {
        // uncheck all
        targetBox.allSecernIds.map((boxSecernId) => {
          const pos = checkedBoxOnModal.indexOf(boxSecernId);
          if (pos > -1) {
            checkedBoxOnModal.splice(pos, 1);
          }
          return null;
        });
        this.setState({ checkedBoxOnModal: [...checkedBoxOnModal] });
        return;
      }
      // checkAll
      targetBox.allSecernIds.map((boxSecernId) => {
        if (checkedBoxOnModal.indexOf(boxSecernId) < 0) {
          checkedBoxOnModal.unshift(boxSecernId);
        }
        return null;
      });
      this.setState({ checkedBoxOnModal: [...checkedBoxOnModal] });
    }
  }

  /**
   * Handle Checkbox event
   */
  handleCheckbox(event) {
    const { value } = event.target;
    const checkedBoxList = [...this.state.checkedBoxList];
    const checkedBoxOnModal = [...this.state.checkedBoxOnModal];

    const pos = checkedBoxList.indexOf(value);
    pos < 0 ? checkedBoxList.unshift(value) : checkedBoxList.splice(pos, 1);

    const pos2 = checkedBoxOnModal.indexOf(value);
    pos2 < 0 ? checkedBoxOnModal.unshift(value) : checkedBoxOnModal.splice(pos2, 1);

    this.setState({ checkedBoxList, checkedBoxOnModal });
  }

  /**
   * Handle 追加 button
   */
  handleAddBox() {
    this.scrollToBottom();
    this.props.dispatch(csvActions.addCheckedBoxToList({ addedList: this.state.checkedBoxOnModal }));
  }

  /**
   * Handle セクション一括削除 button
   */
  handleRemoveAllBoxes() {
    this.setState({
      checkedBoxList: [],
      checkedBoxOnModal: [],
    }, () => {
      this.props.dispatch(csvActions.addCheckedBoxToList({ removedAll: true }));
    });
  }

  /**
   * Handle remove icon button
   */
  handleRemoveBox(boxSecernId) {
    const { checkedBoxList, checkedBoxOnModal } = this.state;
    const pos = checkedBoxList.indexOf(boxSecernId);
    if (pos >= 0) {
      checkedBoxList.splice(pos, 1);
    }
    const pos2 = checkedBoxOnModal.indexOf(boxSecernId);
    if (pos2 >= 0) {
      checkedBoxOnModal.splice(pos2, 1);
    }
    this.setState({
      checkedBoxList, checkedBoxOnModal,
    }, () => {
      this.props.dispatch(csvActions.addCheckedBoxToList({ removedSecern: boxSecernId }));
    });
  }

  /**
   * Handle paging event
   */
  getStartEndData(startPosition) {
    const { invalid, formValues, boxSearchConditions } = this.props;
    if (invalid) return;
    if (boxSearchConditions && Object.keys(boxSearchConditions).length > 0) {
      this.props.dispatch(csvActions.searchBox(boxSearchConditions.boxName,
        boxSearchConditions.userAttributeKeyNum, boxSearchConditions.userAttributeSearchText, startPosition));
    } else {
      this.props.dispatch(csvActions.getBoxListPaging(startPosition));
    }
  }

  /**
   * Handle search box
   */
  handleSearchBox() {
    const { formValues } = this.props;
    const { boxName, userAttributeKeyNum, userAttributeSearchText } = formValues;

    this.props.change('startPosition', 0);
    this.props.dispatch(csvActions.searchBox(boxName, userAttributeKeyNum, userAttributeSearchText));
    this.setState({ isAllowShowSearchMessage: true });
  }

  /**
   * Handle turn off notification message
   */
  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  /**
   * Config header and footer modal
   */
  getModalOptions() {
    return {
      title: '対象となるセクションを指定してください',
      footerBtns: null,
    };
  }

  render() {
    const { userAttributeKeyNum, userAttributeSearchText, targetBox } = this.props;
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <MessageSearch
          recordNum={targetBox ? targetBox.recordNum : 0}
          resultList={targetBox ? targetBox.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        {/* Search Form */}
        <Col sm={12}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSearchBox();
            }}
            className='form-horizontal'
          >
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                セクション名
              </Col>
              <Col sm={8} >
                <RenderField type="text" name="boxName" maxLength="40" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label}>
                自由記述領域
              </Col>
              <Col sm={2}>
                <RenderField
                  type="selectbox"
                  name="userAttributeKeyNum"
                  label="ライブ開催者名"
                  value={userAttributeKeyNum}
                  data={USER_ATTRIBUTE_KEY_NUM_LIST}
                  normalizeSelectBox
                />
              </Col>
              <Col sm={6}>
                <RenderField type="text" name="userAttributeSearchText" label="自由記述領域" value={userAttributeSearchText} />
              </Col>
            </Form.Group>
            <Form.Group className="text-center">
              <Col sm={12} className="margin-top-10 padding-left-right-clear">
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  handleClick={this.handleSearchBox}
                  type="submit"
                  text="検索"
                  iconClass="bi bi-search"
                />
              </Col>
            </Form.Group>
          </Form>
        </Col>

        <BoxList
          targetBox={targetBox}
          checkedBoxOnModal={this.state.checkedBoxOnModal}
          getStartEndData={this.getStartEndData}
          handleCheckAll={this.handleCheckAll}
          handleCheckbox={this.handleCheckbox}
          handleAddBox={this.handleAddBox}
        />
        <SelectedBoxList
          handleRemoveBox={this.handleRemoveBox}
          handleRemoveAllBoxes={this.handleRemoveAllBoxes}
          onCancel={this.onCancel}
          onOK={this.onOK}
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authed, box, csvDownload } = state;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  const formValues = getFormValues('selectBoxDialog')(state);
  const { targetBox, addedBoxList, boxSearchConditions } = csvDownload;
  const data = {
    boxName: '',
    userAttributeKeyNum: 0,
    userAttributeSearchText: '',
  };
  return {
    formValues,
    group,
    userInfo,
    box,
    targetBox,
    addedBoxList,
    csvDownload,
    initialValues: data,
    boxSearchConditions,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'selectBoxDialog', // a unique identifier for this form
  touchOnChange: true,
})(SelectBoxDialog));
